import { jsx as f } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { TextPrimitive as p } from "./index.es799.js";
import { addNonBreakingSpaces as a } from "./index.es2446.js";
const l = n(
  ({ children: e, variant: r, element: o, ...i }, m) => {
    let t;
    return typeof e == "string" && (t = a(e)), /* @__PURE__ */ f(
      p,
      {
        ...i,
        type: "heading",
        role: "heading",
        element: o || r,
        variant: r,
        ref: m,
        children: t ?? e
      }
    );
  }
);
export {
  l as Heading
};
//# sourceMappingURL=index.es507.js.map
